import React, { useState } from "react";
import { useIds } from "../../hook/AdminContext";
import { useSnackbar } from "notistack";
import CustomMUIInput from "../../components/inputsFields/CostomMuiInputs";
import { change_password_of_client } from "../../DAL/auth/auth";
import { getPasswordStrength } from "../../components/menu/PasswirdStrength";
import { InfoIcon } from "lucide-react";
import { close_eye_icon, lock_icon, open_eye_icon } from "../../assets";

const EMPTY_VALUES = {
  old_password: "",
  new_password: "",
  confirm_password: "",
};
function ChangePassword() {
  const [inputs, setInputs] = useState(EMPTY_VALUES);
  const [loading, setLoading] = useState(false);
  const { setUserInfo, userInfo } = useIds();

  const [hidePasswordOne, setHidePasswordOne] = useState(true);
  const [hidePasswordTwo, setHidePasswordTwo] = useState(true);
  const [hidePasswordThree, setHidePasswordThree] = useState(true);

  const { enqueueSnackbar } = useSnackbar();
  const [showRequirements, setShowRequirements] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((old) => ({ ...old, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let error = "";
    const password = inputs.new_password;
    const confirmPassword = inputs.confirm_password;
    let errors = [];
    if (!password) {
      error = "New password is required";
    } else {
      if (password.length < 8) errors.push("At least 8 characters");
      if (!/[A-Z]/.test(password)) errors.push("One uppercase letter (A-Z)");
      if (!/[a-z]/.test(password)) errors.push("One lowercase letter (a-z)");
      if (!/[0-9]/.test(password)) errors.push("One number (0-9)");
      if (!/[^A-Za-z0-9]/.test(password))
        errors.push("One special character (!@#$%^&*)");
      if (errors.length > 0) {
        error = `Password missing: ${errors.join(", ")}`;
      } else if (password !== confirmPassword) {
        error = "New Password and Repeat New Password do not match";
      }
    }

    if (error) {
      enqueueSnackbar(error, { variant: "error" });
      return;
    }

    setLoading(true);
    let data = {
      old_password: inputs.old_password,
      new_password: password,
      confirm_password: confirmPassword,
    };

    const response = await change_password_of_client(userInfo._id, data);
    if (response.code === 200) {
      enqueueSnackbar("Password changed successfully", {
        variant: "success",
      });

      setUserInfo((prev) => {
        const updatedUser = {
          ...prev,
          is_temporary_password: false,
        };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        return updatedUser;
      });

      setInputs(EMPTY_VALUES); // Clear the input fields
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
    setLoading(false);
  };
  return (
    <div className="container">
      <div className="text-center mt-5">
        <h3>Change Password</h3>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-12 col-md-8 col-lg-6">
          <form onSubmit={handleSubmit}>
            {/*  */}
            <div className="custom-input-design">
              <label htmlFor="">Current Password*</label>
              <div className="position-relative">
                <input
                  className="ps-5"
                  name="old_password"
                  onChange={handleChange}
                  placeholder="XXXXXXXX"
                  type={hidePasswordOne ? "password" : "text"}
                  value={inputs.old_password}
                  required
                />
                <img
                  src={lock_icon}
                  alt="lock_icon"
                  className="input-start-icon"
                />
                {hidePasswordOne ? (
                  <img
                    src={open_eye_icon}
                    alt="lock_icon"
                    className="input-end-icon cursor-pointer"
                    onClick={() => setHidePasswordOne(false)}
                  />
                ) : (
                  <img
                    src={close_eye_icon}
                    alt="lock_icon"
                    className="input-end-icon cursor-pointer"
                    onClick={() => setHidePasswordOne(true)}
                  />
                )}
              </div>
            </div>
            {/*  */}
            <div className="custom-input-design mt-3">
              <label htmlFor="">New Password*</label>
              <div className="position-relative">
                <input
                  className="px-5"
                  placeholder="XXXXXXXX"
                  name="new_password"
                  onChange={handleChange}
                  type={hidePasswordTwo ? "password" : "text"}
                  value={inputs.new_password}
                  required
                />
                <img
                  src={lock_icon}
                  alt="lock_icon"
                  className="input-start-icon"
                />

                {hidePasswordTwo ? (
                  <img
                    src={open_eye_icon}
                    alt="lock_icon"
                    className="input-end-icon cursor-pointer"
                    onClick={() => setHidePasswordTwo(false)}
                  />
                ) : (
                  <img
                    src={close_eye_icon}
                    alt="lock_icon"
                    className="input-end-icon cursor-pointer"
                    onClick={() => setHidePasswordTwo(true)}
                  />
                )}
              </div>
            </div>

            {/* Password strength progress bar and label with info icon */}
            {inputs.new_password &&
              (() => {
                const { level, color, percentage } = getPasswordStrength(
                  inputs.new_password
                );
                return (
                  <div className="mt-1 mb-2">
                    <div
                      style={{
                        height: 8,
                        borderRadius: 4,
                        background: "#eee",
                        width: "100%",
                        overflow: "hidden",
                        marginBottom: 6,
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          width: `${percentage}%`,
                          background: color,
                          transition: "width 0.3s, background 0.3s",
                        }}
                      ></div>
                    </div>
                    {/* Strength label with info icon at the end below the bar */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: 14,
                          color: color,
                          textTransform: "capitalize",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {level}
                        <span
                          style={{
                            marginLeft: 6,
                            cursor: "pointer",
                            verticalAlign: "middle",
                            color: "#1976d2",
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                          onClick={() => setShowRequirements((prev) => !prev)}
                          title="Show password requirements"
                        >
                          <InfoIcon
                            style={{ fontSize: 16, color: "#1976d2" }}
                          />
                        </span>
                      </span>
                    </div>
                  </div>
                );
              })()}
            {/* Password requirements shown on info icon click */}
            {showRequirements && inputs.new_password && (
              <div
                style={{
                  background: "#f8f9fa",
                  borderRadius: 6,
                  padding: "12px 16px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                }}
              >
                <strong style={{ fontSize: 14 }}>Password Requirements</strong>
                <ul style={{ fontSize: 13, marginBottom: 0, marginTop: 6 }}>
                  <li>At least 8 characters</li>
                  <li>One uppercase letter (A-Z)</li>
                  <li>One lowercase letter (a-z)</li>
                  <li>One number (0-9)</li>
                  <li>One special character (!@#$%^&*)</li>
                </ul>
              </div>
            )}
            {/*  */}
            <div className="custom-input-design mt-3">
              <label htmlFor="">Confirm Password*</label>
              <div className="position-relative">
                <input
                  className="px-5"
                  name="confirm_password"
                  onChange={handleChange}
                  placeholder="XXXXXXXX"
                  type={hidePasswordThree ? "password" : "text"}
                  value={inputs.confirm_password}
                  required
                />
                <img
                  src={lock_icon}
                  alt="lock_icon"
                  className="input-start-icon"
                />
                {hidePasswordThree ? (
                  <img
                    src={open_eye_icon}
                    alt="lock_icon"
                    className="input-end-icon cursor-pointer"
                    onClick={() => setHidePasswordThree(false)}
                  />
                ) : (
                  <img
                    src={close_eye_icon}
                    alt="lock_icon"
                    className="input-end-icon cursor-pointer"
                    onClick={() => setHidePasswordThree(true)}
                  />
                )}
              </div>
            </div>

            <div className="mt-3">
              <button
                className="theme-button-contained w-100"
                type="submit"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
